module.exports = __webpack_public_path__ + "img/all.42dabfa0.png";